import { object } from '@iwentsourcing/core/typing/object.js';
import { record } from '@iwentsourcing/core/typing/record.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { StateValue } from '@iwentsourcing/core/storage/state-value.js';

export const BrowseItem = object('BrowseItem', {
  data: record(string(), StateValue),
  keys: record(string(), StateValue),
});
